import React from 'react'
import { useApplicationContext } from '../../provider'
import RestrictedPage from './restricted-page'

const InternalRoute = ({ component: Component, location, ...props }) => {
  const { experiments } = useApplicationContext()

  if (!experiments.isInternalUser) {
    return <RestrictedPage />
  }
  return <Component {...props} />
}
export default InternalRoute
